import styled from 'styled-components';

export const CountrySelectorContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const CountrySelectorButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 5px;
  border: 0.5px solid var(--way-colors-borderColor);
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  transition: all 0.2s ease;
  justify-content: center;
  color: var(--way-colors-inputColor);
  min-height: 1px;
  font-style: normal;
  height: 100%;
  box-sizing: border-box;
  border-right: none;

  &:hover {
    border-color: var(--way-colors-borderHoverColor);
  }

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: var(--way-colors-focusColor);
  }

  .flag {
    width: 20px;
    height: 15px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const DropdownArrow = styled.span`
  display: inline-block;
  font-size: 8px;
  color: var(--way-palette-gray-90);
  transition: transform 0.2s ease;
`;

export const CountryDropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 2;
  border: 1px solid var(--way-colors-borderColor);
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  max-height: 300px;
  overflow-y: auto;
  margin-top: 4px;
  min-width: 250px;
  width: auto;
  padding: 0;
  list-style: none;
  background-color: var(--way-palette-white-100);
`;

export const CountryOption = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  text-align: left;
  transition: background-color 0.2s ease;
  color: var(--way-colors-inputColor);

  &:hover,
  &.active {
    background-color: var(--way-palette-gray-10);
  }

  &.selected {
    background-color: var(--way-palette-gray-10);
    color: var(--way-colors-inputColor);
  }

  .flag {
    width: 20px;
    height: 15px;
    flex-shrink: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .country-dial-code {
    font-weight: 500;
    color: var(--way-palette-gray-90);
    font-size: 12px;
  }
`;
